import { Type } from '@angular/core';

export class ModalItemModel {
  constructor(public component: Type<any>, public data: any, public name: string) {}
}
